<div class="position-relative tab-content" *ngIf="tabConfig.isTabsEnabled">
    <span
        *ngIf="(tabsData != {}) && (tabsData.length > 0)"
        (cclClick)="moveLeft()"  title="Move Left"
        class="tab-slide-button left fa fa-arrow-left"
    ></span>

    <drag-scroll #nav [ngClass]="['h-55px']" class="tab-row">
        <div class="tab-container">
            <div title="All Speaker Types"
                drag-scroll-item
                (cclClick)="selectTab($event, 'allSpeakerTypes')"
                [ngClass]="['tab-data', 'ta-center']"
                *ngIf="selectedTabData == 'allSpeakerTypes'"
            >
                <div
                    [ngClass]="{
                        'tab-element active': true,
                        'tab-element-custom active': true,
                        'tab-element-custom-tab': tabConfig.tabStyle === 'tab',
                        'tab-element-custom-underline': tabConfig.tabStyle !== 'tab',
                        active: true
                    }"
                    id="all-speaker-type-label"
                >
                    All Speaker Types
                </div>
            </div>
            <div title="All Speaker Types"
                drag-scroll-item
                (cclClick)="selectTab($event, 'allSpeakerTypes')"
                [ngClass]="['tab-data', 'ta-center']"
                *ngIf="selectedTabData != 'allSpeakerTypes'"
            >
                <div
                    [ngClass]="{
                        'tab-element': true,
                        'tab-element-custom': true,
                        'tab-element-custom-tab': tabConfig.tabStyle === 'tab',
                        'tab-element-custom-underline': tabConfig.tabStyle !== 'tab'
                    }"
                    id="all-speaker-type-label"
                >
                    All Speaker Types
                </div>
            </div>
            <div drag-scroll-item class="tab-data" *ngFor="let tabData of tabsData; let i = index">
                <div title="{{ tabData.label }}"
                    (cclClick)="selectTab($event, tabData)"
                    [ngClass]="['ta-center']"
                    *ngIf="selectedTabData == tabData.id"
                >
                    <div
                        [ngClass]="{
                            'tab-element': true,
                            'active tab-element-custom active': true,
                            'tab-element-custom-tab': tabConfig.tabStyle === 'tab',
                            'tab-element-custom-underline': tabConfig.tabStyle !== 'tab',
                            active: true
                        }"
                    >
                        {{ tabData.label }}
                    </div>
                </div>

                <div title="{{ tabData.label }}"
                    (cclClick)="selectTab($event, tabData)"
                    [ngClass]="['ta-center']"
                    *ngIf="selectedTabData != tabData.id"
                >
                    <div
                        [ngClass]="{
                            'tab-element': true,
                            'tab-element-custom': true,
                            'tab-element-custom-tab': tabConfig.tabStyle === 'tab',
                            'tab-element-custom-underline': tabConfig.tabStyle !== 'tab'
                        }"
                    >
                        {{ tabData.label }}
                    </div>
                </div>
            </div>
        </div>
    </drag-scroll>

    <span
        *ngIf="(tabsData != {}) && (tabsData.length > 0)"
        (cclClick)="moveRight()"  title="Move Right"
        class="tab-slide-button right fa fa-arrow-right"
    ></span>
</div>
<div class="clearfix"></div>
